import {Directive, ElementRef, EventEmitter, HostListener, Output} from '@angular/core';
@Directive({
  selector: '[appClickOutside]'
})
export class ClickOutsideDirectiveDirective {
  @Output() clickOutside = new EventEmitter<void>();
  constructor(private elementRef: ElementRef) {
  }
  @HostListener('document:click', ['$event.target'])
  public onClick(target) {
    const clickedInside = this.elementRef.nativeElement.contains(target);
    if (!clickedInside) {
      this.clickOutside.emit();
    }
  }
}